import { MakeCall } from './createMakeCall';
import { APIV2_URL } from './constants';

export interface ResponseObject {
  Rooms: number;
  Cities: number;
  Countries: number;
}

export default (makeCall: MakeCall) => () =>
  makeCall<ResponseObject>('GET', `${APIV2_URL}/listings/global-counters`);
